import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './theme/globals.css'
import './theme/installer.css'
import { App } from './App.js'
import { initAnalytics } from './lib/analytics.js'

initAnalytics()

const root = document.getElementById('root')
if (!root) throw new Error('root element missing')
createRoot(root).render(<StrictMode><App /></StrictMode>)
